import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How can I book a cab with SG Cabs?",
      answer: "You can book a cab easily through our website booking form, by calling us at +91 75078 67648, or via WhatsApp. Simply share your pickup location, destination, date, and time, and we'll take care of the rest!"
    },
    {
      question: "Are your cab services available 24/7?",
      answer: "Yes, SG Cabs offers round-the-clock cab services, 24 hours a day, 7 days a week. Whether it's an early morning airport transfer or a late-night pickup, we're always available to serve you."
    },
    {
      question: "Do you provide airport pickup and drop services?",
      answer: "Absolutely! SG Cabs specializes in reliable airport transfers with on-time pickups and professional drivers. We offer airport transfers starting from ₹1350 for Sedan and ₹1850 for SUV."
    },
    {
      question: "What types of vehicles are available?",
      answer: "SG Cabs offers a variety of well-maintained vehicles including Sedan (Dzire, Etios) and SUV (Ertiga, Innova). All vehicles are regularly serviced, cleaned, and sanitized for your safety and comfort."
    },
    {
      question: "Can I book cabs for outstation trips?",
      answer: "Yes! SG Cabs provides both one-way and round-trip outstation travel options. Our outstation rates are ₹14/km for Sedan and ₹18/km for SUV. We cover popular routes to Mysore, Coorg, Ooty, Tirupati, and more."
    },
    {
      question: "Do you offer one way intercity drops?",
      answer: "Yes! We offer fixed-fare one way drops between Bengaluru and Hyderabad (Sedan ₹12,999 / SUV ₹15,999), Chennai (₹7,999 / ₹9,999), Tirupati (₹7,999 / ₹9,999), Coimbatore (₹5,999 / ₹7,999), Mysuru (₹3,999 / ₹5,999) and Goa (₹13,999 / ₹15,999). The same fare applies in both directions, and it is all inclusive — driver allowance, fuel, tolls and state permit are covered. You pay only for one way."
    },
    {
      question: "What are your pricing and payment options?",
      answer: "SG Cabs offers transparent and competitive pricing with no hidden charges. Airport transfers start at ₹1350, outstation trips at ₹14/km, and hourly rentals from ₹375/hr. Payment can be made via cash, UPI, or online methods."
    },
    {
      question: "Is there a cancellation policy?",
      answer: "Yes, cancellations are allowed. For the most accurate information about cancellation charges based on your booking timing, please contact us directly at +91 75078 67648."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-[#0a0a0a]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl sm:text-4xl font-semibold text-white mb-4 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Got questions? We've got answers! Find quick answers to common queries about our services.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={faq.question}
              className="lux-card rounded-xl transition-colors duration-300 overflow-hidden"
            >
              {/* Question */}
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center p-6 text-left hover:bg-white/5 transition-colors duration-200"
              >
                <h3 className="text-base font-semibold text-white pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  {openIndex === index ? (
                    <ChevronUp className="w-6 h-6 text-[#d4af37]" />
                  ) : (
                    <ChevronDown className="w-6 h-6 text-gray-500" />
                  )}
                </div>
              </button>

              {/* Answer */}
              <div 
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="p-6 pt-0 border-t border-white/10">
                  <p className="text-gray-400 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center bg-[#121212] rounded-2xl p-8 border border-[#d4af37]/30">
          <h3 className="font-display text-2xl font-semibold text-white mb-3">
            Still have questions?
          </h3>
          <p className="text-gray-400 mb-6">
            Our team is here to help! Contact us anytime for personalized assistance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:+917507867648"
              className="inline-flex items-center justify-center px-6 py-3 bg-[#d4af37] hover:bg-[#c9a35c] text-black font-semibold rounded-full transition-colors"
            >
              Call +91 75078 67648
            </a>
            <a 
              href="https://wa.me/917507867648"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-full transition-colors"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
